import {defineStore} from "pinia";
import {computed, ComputedRef} from "vue";
import {useSessionStorage} from "@vueuse/core";
import {UserInfoType} from "src/composables/server/useHaiiExAuth";
import {useKidsStore} from "stores/useKidsStore";
import {useKidStore} from "stores/useKidStore";
import * as Sentry from "@sentry/vue";
import cookie from "js-cookie";


export const sessionUser = useSessionStorage(
  `forme_b2c_${process.env.VUE_APP_ENV}/loginUser`,
  {} as UserInfoType
);

export const useAuthStore = defineStore("auth", () => {
  const user = sessionUser;

  const getUser: ComputedRef<UserInfoType> = computed(() => {
    return user.value;
  });

  function setUser(userData: UserInfoType) {
    user.value = userData;
    const scope = Sentry.getCurrentScope();
    const jwt = cookie.get("_at") ?? "";
    scope.setExtra("jwt",{jwt : jwt})
    scope.setUser({
      id: userData.uuid,
      email: userData.email,
    });
  }

  function resetUser() {
    user.value = {} as UserInfoType;
  }

  const kidsStore = useKidsStore();
  const kidStore = useKidStore();

  function resetAllStore() {
    kidsStore.resetKids();
    kidStore.resetKid();
    resetUser();
  }

  return {
    user,
    getUser,
    setUser,
    resetUser,
    resetAllStore,
  };
});
